/**
 * API Configuration
 * 
 * Contains configuration for API endpoints and services.
 */

export const API_CONFIG = {
    // Azure Function endpoint for sending beta partner emails
    // This should be replaced with your actual Azure Function URL
    BETA_PARTNER_EMAIL_ENDPOINT: 'https://crossmoore-contact-function.azurewebsites.net/api/SendEmail?code=0txdCBJ2wkY8V0nFBVFOS2KsvHOfZg7Pb1niE82Q9CXJAzFu7eCGpQ%3D%3D'
}; 